import { api } from "./api";
import {
  HealthResponse,
  DatabaseHealthResponse,
} from "../types/common/commonTypes";

export const healthService = {
  // Basic health check
  checkHealth: (): Promise<HealthResponse> =>
    api.get("/health/").then((res) => res.data),

  // Database health check with metrics
  checkDatabaseHealth: (): Promise<DatabaseHealthResponse> =>
    api.get("/health/database").then((res) => res.data),

  // Test API connection
  testConnection: async (): Promise<boolean> => {
    try {
      const response = await healthService.checkHealth();
      return response.status === "healthy";
    } catch (error) {
      console.error("API Connection failed:", error);
      return false;
    }
  },
};

export default healthService;
